import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import {RoleTransformer} from '../helpers/enum/role-transformer';
import {Role} from './role';
import * as moment from 'moment';
import {MomentTransformer} from '../helpers/moment-transformer';
import {ModelBase} from './model-base';
import {Observable, of} from 'rxjs';

@inheritSerialization(ModelBase)
export class User extends ModelBase {
  public static readonly type: 'User' | 'Customer' = 'User';
  public readonly type: 'User' | 'Customer' = User.type;

  @autoserialize
  public id: number;

  @autoserializeAs('account_id')
  public accountId: number;

  @autoserializeAs('event_id')
  public eventId: number;

  @autoserializeAs('first_name')
  public firstName: string;

  @autoserializeAs('last_name')
  public lastName: string;

  @autoserializeAs('blocked')
  public blocked: boolean;

  @autoserializeAs(RoleTransformer, 'rol')
  public role: Role;

  @autoserializeAs(MomentTransformer, 'created_at')
  public createdAt: moment.Moment;

  @autoserializeAs('group_id')
  public groupId: number;

  @autoserializeAs('group_name')
  public groupName: string;

  @autoserializeAs('group_can_register_introducees')
  public groupCanRegisterIntroducees: string;

  @autoserializeAs('registered')
  public registered: boolean;

  @autoserializeAs('email_address')
  public emailAddress: string;

  public name(): string {
    return this.firstName + ' ' + this.lastName;
  }

  public isPrivileged(): Observable<boolean> {
    return of(this.role === Role.Admin || this.role === Role.Organisator || this.role === Role.Ceremoniemeester);
  }

}
